import { FormLabel, Grid, makeStyles, Typography } from "@material-ui/core";
import React, { FC } from "react";
import { TranslationKey } from "../../../translations/TranslationKey";
import TranslatedMessage from "../../translations/TranslatedMessage";

const useStyles = makeStyles(() => ({
  labelContainer: {
    display: "flex",
    alignItems: "center",
  },
}));

interface ExamSessionCandidateExamRowProps {
  labelTranslationKey: TranslationKey;
  value: string | JSX.Element;
}

const ExamSessionCandidateExamRow: FC<ExamSessionCandidateExamRowProps> = ({ labelTranslationKey, value }) => {
  const classes = useStyles();
  return (
    <>
      <Grid item={true} xs={12} sm={6} className={classes.labelContainer}>
        <FormLabel component="legend">
          <Typography>
            <TranslatedMessage id={labelTranslationKey} />
          </Typography>
        </FormLabel>
      </Grid>
      <Grid item={true} xs={12} sm={6}>
        {value}
      </Grid>
    </>
  );
};

export default ExamSessionCandidateExamRow;
